import { useNavigate } from 'react-router-dom';

import Button from '@lib/core/src/components/Button';

import RoutesMap from '@/enums/RoutesMap';
import {
  Container,
  Title,
  TitleDescription,
  TitlesContainer
} from '@/pages/LoginFlow/ForgotPassword/ForgotPasswordStyles';

const ResetSuccess = () => {
  const navigate = useNavigate();

  return (
    <Container>
      <TitlesContainer>
        <Title>Awesome!</Title>
        <TitleDescription>
          Your password has been reset successfully. You can continue your journey shortly.
        </TitleDescription>
      </TitlesContainer>
      <Button text="Continue" onClick={() => navigate(RoutesMap.Login)} />
    </Container>
  );
};

export default ResetSuccess;
